import { TooltipCode } from 'areas/shared/consts';

const IncorporationArticles = { 
    code: "IncorporationArticles", 
    visible: false,
    description: ""
};

const IncorporationCertificate = { 
    code: "IncorporationCertificate", 
    visible: false,
    description: ""
};

const CorporateByLaws = { 
    code: "CorporateByLaws", 
    visible: false,
    description: ""
};

const ForeignEntityCertificate = {
    code: "ForeignEntityCertificate", 
    visible: true,
    description: "Foreign Entity Certificate",
    tooltipCode: TooltipCode.ARTICLE.FOREIGNENTCERUPLOAD
};

const OfficersElectedMinutes = { 
    code: "OfficersElectedMinutes", 
    visible: false,
    description: ""
};

const FirstBoardMeetingMinutes = { 
    code: "FirstBoardMeetingMinutes", 
    visible: false,
    description: ""
};

const MostRecentMeetingMinutes = { 
    code: "MostRecentMeetingMinutes", 
    visible: false,
    description: ""
};

const CapitalContributionProof = { 
    code: "CapitalContributionProof", 
    visible: true,
    description: "Proof of Capital Investment by majority owner at time of company start or<br />owner's acquisition",
    tooltipCode: TooltipCode.ARTICLE.CAPINVESTPROOF
};

const StockPurchaseProof = { 
    code: "StockPurchaseProof", 
    visible: false,
    description: ""
};
const CorporateStockCertificates = { 
    code: "CorporateStockCertificates", 
    visible: false,
    description: ""
};

const CorporateStockLedger = {
    code: "CorporateStockLedger",
    visible: false,
    description: ""
};

const OperationalAgreement = {
    code: "OperationalAgreement",
    visible: false,
    description: ""
};

const BuyOutRights = {
    code: "BuyOutRights",
    visible: true,
    description: "Buy Out Rights",
    tooltipCode: TooltipCode.ARTICLE.BUYOUTRIGHTSUPLOAD
};

const LimitedPartnershipCertificate = {
    code: "LimitedPartnershipCertificate",
    visible: true,
    description: "Certificate of Limited Partnership",
    tooltipCode: TooltipCode.ARTICLE.LIMITEDPTRCERUPLOAD
};

const LimitedPartnershipDocuments = {
    code: "LimitedPartnershipDocuments",
    visible: true,
    description: "General/Limited Partnership Corporate Documents",
    tooltipCode: TooltipCode.ARTICLE.GENLIMPARTCORPDOCUPLOAD
};

const PartnershipAgreements = {
    code: "PartnershipAgreements",
    visible: true,
    description: "Partnership Agreements",
    tooltipCode: TooltipCode.ARTICLE.PARTNERSHIPAGRUPLOAD
};

const ProfitSharing = {
    code: "ProfitSharing",
    visible: true,
    description: "Profit Sharing",
    tooltipCode: TooltipCode.ARTICLE.PROFITSHARUPLOAD
};

const ThirdPartyAgreements = {
    code: "ThirdPartyAgreements",
    visible: false,
    description: ""
};

export default {
    IncorporationArticles,
    IncorporationCertificate,
    CorporateByLaws,
    ForeignEntityCertificate,
    OfficersElectedMinutes,
    FirstBoardMeetingMinutes,
    MostRecentMeetingMinutes,
    CapitalContributionProof,
    StockPurchaseProof,
    CorporateStockCertificates,
    CorporateStockLedger,
    OperationalAgreement,
    BuyOutRights,
    LimitedPartnershipCertificate,
    LimitedPartnershipDocuments,
    PartnershipAgreements,
    ProfitSharing,
    ThirdPartyAgreements
};


// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/articles/UploadsConfig/LlpConfig.js